function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "165px",
    height: "165px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#2a2d82",
    d: "M -0.5,-0.5 C 54.5,-0.5 109.5,-0.5 164.5,-0.5C 164.5,54.5 164.5,109.5 164.5,164.5C 109.5,164.5 54.5,164.5 -0.5,164.5C -0.5,109.5 -0.5,54.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4ebf3",
    d: "M 51.5,37.5 C 60.3766,36.1057 67.0433,39.2723 71.5,47C 73.1667,47.1667 74.8333,47.3333 76.5,47.5C 79.7698,46.8461 82.9365,46.8461 86,47.5C 92.0041,43.7209 98.5041,41.5542 105.5,41C 106.022,41.5613 106.355,42.228 106.5,43C 105.923,46.0558 105.257,49.0558 104.5,52C 113.931,48.9242 121.097,51.7575 126,60.5C 126.667,63.1667 126.667,65.8333 126,68.5C 122.392,74.3962 117.559,79.0628 111.5,82.5C 112.833,83.6199 113.333,84.9532 113,86.5C 111.702,87.5596 110.535,88.7263 109.5,90C 102.677,102.648 95.3437,114.981 87.5,127C 83.1667,127.667 78.8333,127.667 74.5,127C 73.4053,124.731 73.7386,122.564 75.5,120.5C 74.5,120.167 73.5,119.833 72.5,119.5C 67.4362,122.079 62.1028,124.079 56.5,125.5C 56.8115,117.772 56.3115,110.105 55,102.5C 49.5862,104.761 47.4196,102.928 48.5,97C 47.8928,91.794 50.2262,89.4606 55.5,90C 46.9662,87.1302 41.4662,81.2969 39,72.5C 34.8113,57.5486 38.978,45.8819 51.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#116431",
    d: "M 107.5,53.5 C 118.824,52.3256 123.991,57.3256 123,68.5C 119.202,74.2306 114.202,78.564 108,81.5C 108.152,83.0761 108.985,84.4095 110.5,85.5C 105.909,86.0563 101.909,84.5563 98.5,81C 100.134,80.5065 101.801,80.3398 103.5,80.5C 101.751,73.5982 101.251,66.5982 102,59.5C 103.36,56.9774 105.193,54.9774 107.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#30aae1",
    d: "M 51.5,39.5 C 59.188,38.2626 65.0213,40.9293 69,47.5C 70.4872,50.481 71.8206,53.481 73,56.5C 73.2362,54.236 73.7362,52.0693 74.5,50C 78.1516,49.5014 81.8183,49.3347 85.5,49.5C 85.7574,53.8917 86.4241,58.225 87.5,62.5C 88.1667,57.5 88.8333,52.5 89.5,47.5C 94.0104,45.5512 98.6771,44.2179 103.5,43.5C 101.126,57.6593 98.126,71.6593 94.5,85.5C 91.4552,85.5079 88.4552,85.8413 85.5,86.5C 84.2379,81.0466 82.5712,75.7133 80.5,70.5C 78.9967,74.3553 78.3301,78.3553 78.5,82.5C 75.1589,83.0053 71.8255,83.1719 68.5,83C 69.5171,81.9505 69.6838,80.7839 69,79.5C 64.0667,86.4912 57.5667,88.3245 49.5,85C 44.4242,80.6823 41.5908,75.1823 41,68.5C 38.3609,56.4725 41.8609,46.8058 51.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaf0f7",
    d: "M 55.5,53.5 C 59.0433,53.872 61.21,55.872 62,59.5C 62.6667,63.8333 62.6667,68.1667 62,72.5C 57.9193,76.897 54.9193,76.2304 53,70.5C 52.3333,65.8333 52.3333,61.1667 53,56.5C 54.045,55.6266 54.8783,54.6266 55.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e2d82",
    d: "M 56.5,55.5 C 59.3863,58.4827 60.7197,62.1493 60.5,66.5C 60.9838,69.5752 59.9838,71.9085 57.5,73.5C 53.9555,67.6434 53.6222,61.6434 56.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eceff1",
    d: "M 108.5,63.5 C 114.803,63.9239 116.469,66.7572 113.5,72C 106.416,72.475 104.749,69.6417 108.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#27247c",
    d: "M 108.5,65.5 C 112.5,64.8333 114.167,66.5 113.5,70.5C 108.58,71.585 106.913,69.9183 108.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#545097",
    d: "M 98.5,73.5 C 99.6491,73.7911 100.316,74.6244 100.5,76C 100.167,76.8333 99.8333,77.6667 99.5,78.5C 98.5481,76.9547 98.2148,75.288 98.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#46458f",
    d: "M 96.5,83.5 C 98.9828,83.73 99.4828,84.3966 98,85.5C 96.9701,85.1639 96.4701,84.4972 96.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#64609f",
    d: "M 72.5,85.5 C 72.8333,86.1667 73.1667,86.8333 73.5,87.5C 70.0795,87.5168 66.7462,87.6835 63.5,88C 64.5786,87.044 65.7453,86.2106 67,85.5C 68.7067,86.1383 70.54,86.1383 72.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#211e79",
    d: "M 73.5,87.5 C 73.1667,86.8333 72.8333,86.1667 72.5,85.5C 77.104,86.6214 79.9374,84.9547 81,80.5C 82.3186,82.2495 82.8186,84.2495 82.5,86.5C 79.8205,86.6726 77.4872,87.6726 75.5,89.5C 74.8182,88.7573 74.1515,88.0906 73.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b2479",
    d: "M 91.5,87.5 C 92.3764,87.3691 93.0431,87.7025 93.5,88.5C 92.332,91.4689 90.9987,91.8022 89.5,89.5C 90.2427,88.8182 90.9094,88.1515 91.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2fa9e0",
    d: "M 96.5,87.5 C 100.067,87.867 103.4,88.867 106.5,90.5C 100.419,101.663 94.086,112.663 87.5,123.5C 83.8333,124.833 80.1667,124.833 76.5,123.5C 80.0882,117.325 83.4215,110.991 86.5,104.5C 83.2533,100.341 80.2533,96.0076 77.5,91.5C 80.039,88.9597 83.039,88.1263 86.5,89C 87.7079,91.2503 89.0413,93.417 90.5,95.5C 92.8777,93.1215 94.8777,90.4549 96.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#32a9e0",
    d: "M 67.5,89.5 C 69.1667,89.5 70.8333,89.5 72.5,89.5C 72.6633,91.8568 72.4966,94.1902 72,96.5C 70.3005,97.4061 68.4672,97.7394 66.5,97.5C 66.5,105.167 66.5,112.833 66.5,120.5C 63.8333,121.167 61.1667,121.833 58.5,122.5C 58.5,114.833 58.5,107.167 58.5,99.5C 56.0628,99.7563 53.7294,100.423 51.5,101.5C 50.1667,98.8333 50.1667,96.1667 51.5,93.5C 56.8629,91.7668 62.1962,90.4334 67.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#30a8e0",
    d: "M 73.5,96.5 C 79.2533,96.42 82.2533,99.2534 82.5,105C 82.5817,109.761 80.9151,113.761 77.5,117C 69.9171,118.588 66.5838,115.422 67.5,107.5C 67.5153,105.366 68.0153,103.366 69,101.5C 70.7073,99.9625 72.2073,98.2959 73.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7e1ef",
    d: "M 74.5,101.5 C 77.4648,101.73 78.7981,103.397 78.5,106.5C 78.3078,108.577 77.8078,110.577 77,112.5C 75.6439,113.38 74.1439,113.714 72.5,113.5C 72.0792,109.258 72.7459,105.258 74.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c287e",
    d: "M 75.5,103.5 C 76.9095,106.178 76.7428,108.844 75,111.5C 74.2782,108.739 74.4448,106.073 75.5,103.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a68a7bfe1645d15b9c9441aa5541f7d9.svg";
export { ForwardRef as ReactComponent };